;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { TERMS_ACCEPTANCE_PATH } from '@workspace/ui/lib';

// OAuth consent for external connectors (Claude, ChatGPT). Signed-in users stay on it instead of
// being sent to their app, and login and 2FA return to it.
export const OAUTH_CONSENT_PATH = '/oauth/consent';

// Define public routes that don't require authentication
export const PUBLIC_ROUTES = [];

// Define routes that should only be accessible to unauthenticated users
export const GUEST_ONLY_ROUTES = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/two-factor-auth',
  '/set-password',
  '/expired-activation',
  TERMS_ACCEPTANCE_PATH,
  '/.well-known/assetlinks.json',
  '/.well-known/apple-app-site-association',
];
